"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _link = _interopRequireDefault(require("../../../core/link"));
var _navTabs = _interopRequireDefault(require("../../../core/nav-tabs"));
var _summary = _interopRequireDefault(require("./summary"));
var _payments = _interopRequireDefault(require("./payments"));
var _paymentsByEntries = _interopRequireDefault(require("./payments-by-entries"));
var _fullWidth = _interopRequireDefault(require("../../../root/full-width"));
var _notFound = _interopRequireDefault(require("../../../not-found"));
var _requireAuthentication = _interopRequireDefault(require("../../../require-authentication"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, "You must be logged in as the competition organiser to manage competition finances.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Finance({
  loaded,
  competition,
  match: {
    url,
    path
  }
}) {
  if (loaded && !competition.isAdministratedByUser) {
    return _ref;
  }
  return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/summary'
  }, "Summary")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/payments'
  }, "On-line Payments")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/payments-by-entries'
  }, "Payments By Entries"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/summary',
    component: _summary.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/payments',
    component: _payments.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/payments-by-entries',
    component: _paymentsByEntries.default
  }), _ref2))));
}
var _ref3 = {
  isAdministratedByUser: true
};
var _default = exports.default = (0, _requireAuthentication.default)((0, _reactBicycle.connect)(Finance, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref3
}), undefined, {
  renderLoading: true
}));